var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "app-main-inner write-off-detail-dialog",
      attrs: {
        no: "writeOffList",
        visible: _vm.innerVisible,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        title: _vm.$t("Payment.writeOffList"),
        width: "1200px"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "section grid-wrapper", staticStyle: { width: "100%" } },
        [
          _c("cargo-ag-grid", {
            attrs: {
              no: "191003-gird",
              "config-module": "191003",
              "grid-params": _vm.gridParams,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              }
            }
          })
        ],
        1
      ),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
        _c(
          "span",
          {
            staticStyle: {
              position: "absolute",
              left: "0",
              "padding-left": "10px"
            }
          },
          [
            _c("span", [_vm._v(_vm._s(_vm.$t("WriteOff.totalWriteOffs")))]),
            !_vm.isBill && _vm.reCalc
              ? _c("charge-currency-total-group", {
                  attrs: {
                    "ar-field": "ar",
                    "currency-field": "clearCurrency",
                    "data-field": "clearAmount",
                    type: _vm.totalGroupType,
                    "data-provider": _vm.totalGroup,
                    "amount-to-currency-label": _vm.$t(
                      "WriteOff.totalWriteOffs"
                    )
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _c(
          "span",
          [
            false
              ? _c(
                  "el-button",
                  {
                    attrs: { no: "cancelPartialWriteOff", type: "primary" },
                    on: { click: _vm.onPartRollback }
                  },
                  [_vm._v(_vm._s(_vm.$t("WriteOff.cancelPartialWriteOff")))]
                )
              : _vm._e(),
            _c(
              "el-button",
              {
                attrs: { no: "exportToExcel", type: "primary" },
                on: { click: _vm.onExport }
              },
              [
                _c("svg-icon", {
                  staticStyle: {
                    "font-size": "12px",
                    "vertical-align": "bottom"
                  },
                  attrs: { "icon-class": "excel" }
                }),
                _vm._v(_vm._s(_vm.$t("WriteOff.exportToExcel")))
              ],
              1
            ),
            _c(
              "el-button",
              {
                attrs: { no: "exportPDF", type: "primary" },
                on: { click: _vm.onExportPdf }
              },
              [
                _c("svg-icon", {
                  staticStyle: {
                    "font-size": "12px",
                    "vertical-align": "bottom"
                  },
                  attrs: { "icon-class": "excel" }
                }),
                _vm._v(_vm._s(_vm.$t("WriteOff.exportPDF")))
              ],
              1
            ),
            _c(
              "el-button",
              {
                attrs: { no: "print", type: "primary" },
                on: { click: _vm.onPrint }
              },
              [_vm._v(_vm._s(_vm.$t("WriteOff.print")))]
            )
          ],
          1
        )
      ]),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.cxt,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }